import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-suspend-footer',
  templateUrl: './suspend-footer.component.html',
  styleUrls: ['./suspend-footer.component.scss'],
})
export class SuspendFooterComponent {
  @Input() itemName: string;
  isMobile: boolean;
  isIosApp = false;
  constructor(private router: Router, private platform: Platform) {
    this.isMobile = this.platform.platforms().includes('capacitor');
  }

  navigateToSub() {
    this.router.navigate(['/payments/subscription']);
  }
}

